import React from "react";
import { Typography, Avatar } from "@material-ui/core";
import { blueGrey } from '@material-ui/core/colors';

export default function WalletMerchantView(props: any) {
    return (
        <div style={{
            margin: 30,
        }}>
            <a href={props.link} target="_blank" rel="noopener noreferrer" style={{
                textDecoration: 'none',
                color: blueGrey[900],
            }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                    <Avatar variant="circle"
                        src={props.imageSrc}
                        style={{
                            height: props.title.toLowerCase().includes("blockchain") ? 95 : 100,
                            width: 100,
                            padding: 10,
                        }} />
                    <Typography style={{ fontSize: 20, fontWeight: 600 }}>{props.title}</Typography>
                </div>
            </a>
        </div>
    );
}